export default __webpack_public_path__ + "static/media/room-3-theme.ca4d9931.webp";